import { render } from "./AutoplayAudio.vue?vue&type=template&id=37fe76a6"
import script from "./AutoplayAudio.vue?vue&type=script&lang=js"
export * from "./AutoplayAudio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__